import steps from "@/helpers/constants/steps";

import apiCatalog from "@/api/catalog";

import { i18n } from "@v2/shared/config";
import shortid from "shortid";
import currencies from "@/helpers/constants/currencies";
import eventCatalogHelper from "@/helpers/eventCatalog";
import apiCommon from "@/api/common";
import event from "./event";
import store from "@/store";
import getError from "@/helpers/error";

const state = {
  steps,

  step: steps.ALPHABET_LIST,

  status: "",

  /**
   * Шаблон заявки на размещение из 1С
   */
  info: {
    services: []
  },

  /**
   * Данные об шаге "алфавитный список участников"
   */
  alphabetList: {},

  // выбранные id рубрик
  selectedRubricsId: [],

  // невалидные стенды
  invalidStands: [],

  // выбранные сервисы для рубрики
  // RUBRIC_ID => [SERVICE_ID_1, SERVICE_ID_2, SERVICE_ID_3]
  selectedServicesForRubrics: {},

  // выбранные id Российского экспортёра
  selectedRussianExporterId: [],

  // выбранные пакеты на шаге рубрикатора
  selectedPackagesId: [],

  /**
   * Данные об шаге "пакетное размещение"
   */
  packagePlacement: {
    selectedMajorPackageIds: [],
    selectedAdditionalPackageId: [],
    selectedLogoPlacementIds: []
  },
  isRequiredUploadLogo: false,
  packagePlacementLogoLink: null,

  /**
   * Данные о шаге рекламные услуги
   */
  adServices: {
    catalog: [],
    guide: [],
    other: [],
    graphicFilesLink: null,
    adVideoFilesLink: null
  },

  rubrics: [],

  rubricsAddresses: [],

  currentCurrencyType: currencies.find(currency => currency.code === "RUR"),
  currenciesComparisonTable: currencies,
  countryList: [],
  files: {
    orderFile: null,
    requisitesFile: null,
    logoFile: null,
    coverImg: null,
    adModulePdf: null,
    adGraphic: null
  },
  isCatalogDataLoading: true
};

const mutations = {
  RESET_CATALOG_ORDER_STATE(state) {
    state.step = steps.ALPHABET_LIST;
    state.status = "draft";
    state.info = {};
    state.alphabetList = {};
    state.selectedRubricsId = [];
    state.invalidStands = [];
    state.selectedServicesForRubrics = {};
    state.selectedRussianExporterId = [];
    state.selectedPackagesId = [];
    state.packagePlacement = {
      selectedMajorPackageIds: [],
      selectedAdditionalPackageId: [],
      selectedLogoPlacementIds: []
    };
    state.packagePlacementLogoLink = null;
    state.adServices = {
      catalog: [],
      guide: [],
      other: [],
      graphicFilesLink: null,
      adVideoFilesLink: null
    };
    state.rubrics = [];
    state.currentCurrencyType = currencies.find(
      currency => currency.code === "RUR"
    );
    state.currenciesComparisonTable = currencies;
    state.files = {
      orderFile: null,
      requisitesFile: null,
      logoFile: null,
      coverImg: null,
      adModulePdf: null,
      adGraphic: null
    };
  },
  SET_INFO(state, info) {
    state.info = info;
  },
  SET_STANDS_ON_EMPTY_CATALOG(state) {
    if (event.state.event.type === "sub") {
      state.alphabetList.companyStands = [
        { id: shortid.generate(), value: "" }
      ];
    } else {
      state.alphabetList.companyStands =
        event.state.event.stands?.map(stand => {
          return {
            id: shortid.generate(),
            value: stand.title
          };
        }) || [];
    }
  },
  UPDATE_STEP(state, step) {
    state.step = step;
  },

  UPDATE_CATALOG(state, catalog) {
    state.status = catalog.status;
    state.alphabetList = catalog.alphabetList;
    state.selectedRubricsId = catalog.selectedRubricsId;
    state.selectedRussianExporterId = catalog.selectedRussianExporterId;
    state.selectedPackagesId = catalog.selectedPackagesId;
    state.selectedServicesForRubrics = catalog.selectedServicesForRubrics;
    state.packagePlacement = catalog.packagePlacement;
    state.rubricsAddresses = catalog.rubricsAddresses;
    state.adServices = catalog.adServices;
    state.files = catalog.files;
    state.currentCurrencyType = catalog.currentCurrencyType;
  },

  SET_RUBRICS(state, rubrics) {
    state.rubrics = rubrics;
  },

  UPDATE_RUBRICS(state, selectedRubricsId) {
    state.selectedRubricsId = selectedRubricsId;
  },

  UPDATE_RUBRICS_ADDRESSES(state, addresses) {
    state.rubricsAddresses = addresses;
  },

  UPDATE_RUSSIAN_EXPORTERS_LIST(state, selectedRussianExporterId) {
    state.selectedRussianExporterId = selectedRussianExporterId;
  },

  ADD_INVALID_STAND(state, id) {
    const stands = state.invalidStands;
    const index = stands.indexOf(id);
    if (index === -1) {
      stands.push(id);
      state.invalidStands = stands;
    }
  },

  DELETE_INVALID_STAND(state, id) {
    const stands = state.invalidStands;
    const index = stands.indexOf(id);
    if (index !== -1) {
      stands.splice(index, 1);
    }

    this.invalidStands = stands;
  },

  UPDATE_ALPHABET_LIST_FIELD(state, { field, value }) {
    const alphabetList = { ...state.alphabetList };
    alphabetList[field] = value;
    state.alphabetList = alphabetList;
  },

  ENABLE_SERVICE_FOR_RUBRIC(state, payload) {
    let selectedServicesForRubrics = { ...state.selectedServicesForRubrics };

    if (!selectedServicesForRubrics[payload.rubricId]) {
      selectedServicesForRubrics[payload.rubricId] = [];
    }

    if (
      selectedServicesForRubrics[payload.rubricId].indexOf(
        payload.serviceId
      ) === -1
    ) {
      selectedServicesForRubrics[payload.rubricId].push(payload.serviceId);
    }

    state.selectedServicesForRubrics = selectedServicesForRubrics;
  },

  DISABLE_SERVICE_FOR_RUBRIC(state, payload) {
    let selectedServicesForRubrics = { ...state.selectedServicesForRubrics };

    if (!selectedServicesForRubrics[payload.rubricId]) {
      return;
    }

    const index = selectedServicesForRubrics[payload.rubricId].indexOf(
      payload.serviceId
    );

    if (index > -1) {
      selectedServicesForRubrics[payload.rubricId].splice(index, 1);
    }

    if (!selectedServicesForRubrics[payload.rubricId].length) {
      delete selectedServicesForRubrics[payload.rubricId];
    }

    state.selectedServicesForRubrics = selectedServicesForRubrics;
  },

  DELETE_RUBRIC(state, rubricId) {
    let selectedRubricsId = [...state.selectedRubricsId],
      selectedServicesForRubrics = { ...state.selectedServicesForRubrics };

    const index = selectedRubricsId.indexOf(String(rubricId));

    if (index > -1) {
      selectedRubricsId.splice(index, 1);
    }

    delete selectedServicesForRubrics[rubricId];

    state.selectedRubricsId = selectedRubricsId;
    state.selectedServicesForRubrics = selectedServicesForRubrics;
  },

  UPDATE_PACKAGE_PLACEMENT_MAJOR_PACKAGE(state, packageId) {
    let packages = [...state.packagePlacement.selectedMajorPackageIds];

    if (packages.indexOf(packageId) > -1) {
      packages.splice(packages.indexOf(packageId), 1);
    } else {
      packages.push(packageId);
    }

    state.packagePlacement.selectedMajorPackageIds = packages;
  },

  UPDATE_PACKAGE_PLACEMENT_ADDITIONAL_PACKAGE(state, packageId) {
    let packages = [...state.packagePlacement.selectedAdditionalPackageId];

    if (packages.indexOf(packageId) > -1) {
      packages.splice(packages.indexOf(packageId), 1);
    } else {
      packages.push(packageId);
    }
    state.packagePlacement.selectedAdditionalPackageId = packages;
  },

  UPDATE_PACKAGE_PLACEMENT_LOGO(state, { service, value }) {
    let logo = [...state.packagePlacement.selectedLogoPlacementIds];

    if (value) {
      logo.push(service.id);
    } else if (logo.indexOf(service.id) > -1) {
      logo.splice(logo.indexOf(service.id), 1);
    }

    state.packagePlacement.selectedLogoPlacementIds = logo;
  },

  UPDATE_AD_SERVICE_CATALOG(state, { service, value }) {
    let catalog = [...state.adServices.catalog];

    if (value) {
      catalog.push(service.id);
    } else {
      const index = catalog.indexOf(service.id);

      if (index > -1) {
        catalog.splice(index, 1);
      }
    }

    state.adServices.catalog = catalog;
  },

  UPDATE_AD_SERVICE_GUIDE(state, { service, value }) {
    let guide = [...state.adServices.guide];

    if (value) {
      guide.push(service.id);
    } else {
      const index = guide.indexOf(service.id);

      if (index > -1) {
        guide.splice(index, 1);
      }
    }

    state.adServices.guide = guide;
  },

  UPDATE_AD_SERVICE_OTHER(state, { service, value }) {
    let other = [...state.adServices.other];

    if (value) {
      other.push(service.id);
    } else {
      const index = other.indexOf(service.id);

      if (index > -1) {
        other.splice(index, 1);
      }
    }

    state.adServices.other = other;
  },

  SET_PACKAGE_PLACEMENT_GRAPHIC_FILES_LINK(state, payload) {
    state.adServices.graphicFilesLink = payload;
  },
  SET_PACKAGE_PLACEMENT_VIDEO_LINK(state, payload) {
    state.adServices.adVideoFilesLink = payload;
  },
  SET_CURRENT_CURRENCY_TYPE(state, type) {
    state.currentCurrencyType = type;
  },

  UPDATE_FILE_ORDER(state, payload) {
    state.files.orderFile = payload;
  },

  UPDATE_FILE_REQUISITES(state, payload) {
    state.files.requisitesFile = payload;
  },

  UPDATE_FILE_LOGO(state, payload) {
    state.files.logoFile = payload;
  },
  UPDATE_FILE_PRESENTATION(state, payload) {
    state.files.adModulePdf = payload;
  },
  UPDATE_GRAPHIC_FILES(state, payload) {
    state.files.adGraphic = payload;
  },
  UPDATE_FILE_COVER(state, payload) {
    state.files.coverImg = payload;
  },
  IS_REQUIRED_UPLOAD_LOGO(state, payload) {
    state.isRequiredUploadLogo = payload;
  },
  SET_COUNTRY_LIST(state, payload) {
    state.countryList = payload;
  },
  IS_CATALOG_DATA_LOADING(state, payload) {
    state.isCatalogDataLoading = payload;
  }
};

const actions = {
  loadingCatalogData({ commit }, payload) {
    commit("IS_CATALOG_DATA_LOADING", payload);
  },
  loadCountryList({ commit }) {
    apiCommon
      .getCountryList()
      .then(countries => {
        if (countries && countries.data) {
          return countries.data.map(country => {
            return {
              value: country.id,
              title: i18n.locale === "en" ? country.name_eng : country.name_rus,
              isCatalogOrderRuLocale: country.is_catalog_order_ru_locale
            };
          });
        }
      })
      .then(data => {
        commit("SET_COUNTRY_LIST", data);
      })
      .catch(response => {
        console.error(
          "Не удалось получить страны: " + JSON.stringify(response)
        );
      });
  },
  isRequiredUploadLogo({ commit }, payload) {
    commit("IS_REQUIRED_UPLOAD_LOGO", payload);
  },
  resetCatalogOrderState({ commit }) {
    commit("RESET_CATALOG_ORDER_STATE");
  },
  async fetchInfo({ commit }, payload) {
    // запрашивает шаблон заявки на размещение в каталоге
    const response = await apiCatalog.getTemplate(
      payload.eventId,
      payload.templateId
    );
    const data = response?.data;
    if (data) {
      commit("SET_INFO", JSON.parse(JSON.stringify(data)));
    } else {
      commit("SET_INFO", JSON.parse(JSON.stringify({})));
    }
  },

  // запрашивает данные по заказу
  async fetchData({ state, commit }, payload) {
    const result = await apiCatalog.get(payload.eventId, payload.orderId);
    const data = result?.data;
    const isCompanyCountryForBookletIsRussian = data.catalog_country
      ? data.catalog_country.name_rus.toLowerCase() === "россия"
      : "";
    let order = {
      status: data.status,

      currentCurrencyType: state.currenciesComparisonTable.find(
        el => el.code === data.currency
      ),

      alphabetList: {
        companyName: data.name_rus,
        companyNameEng: data.name_eng,
        companyRussianExporter:
          !!data.is_russian_exporter && isCompanyCountryForBookletIsRussian,
        companyEmail: data.email,
        companyPhone: data.phone,
        companyFax: data.fax,
        companyInfo: data.information_rus,
        companyInfoEng: data.information_eng,
        companySite: data.website,
        companyCountry: data.country ? data.country.id : null,
        companyCountryName: data.country
          ? i18n.locale === "en"
            ? data.country.name_eng
            : data.country.name_rus
          : null,
        companyCountryForBooklet: data.catalog_country
          ? data.catalog_country.id
          : null,
        companyCountryForBookletName: data.catalog_country
          ? i18n.locale === "en"
            ? data.catalog_country.name_eng
            : data.catalog_country.name_rus
          : null,
        companyOwnerType: data.type,
        companyAddresses: [
          {
            id: shortid.generate(),
            address: data.address || ""
          }
        ],

        companyStands: [],

        companyIsMark: data.is_mark,
        companyIsContractManufacturing: data.is_contract_manufacturing
      },
      packagePlacement: {
        selectedMajorPackageIds: [],
        selectedAdditionalPackageId: [],
        selectedLogoPlacementIds: []
      },
      adServices: {
        catalog: [],
        guide: [],
        other: [],
        graphicFilesLink: data.logo_link,
        adVideoFilesLink: data.video_link
      },
      selectedRubricsId: [],
      rubricsAddresses: [],
      selectedServicesForRubrics: {},
      selectedRussianExporterId: [],
      selectedPackagesId: []
    };
    const emptyStand = {
      id: shortid.generate(),
      value: ""
    };
    order.alphabetList.companyStands =
      data.stands?.map(stand => {
        return {
          id: shortid.generate(),
          value: stand
        };
      }) || [];
    if (!order.alphabetList.companyStands.length) {
      order.alphabetList.companyStands.push(emptyStand);
    }
    if (data.services && data.services.length) {
      data.services
        .filter(service => !service.rubric_id)
        .forEach(service => {
          const extraService = state.info.services.find(
            infoService => infoService.id === service.id
          );
          if (extraService) {
            switch (extraService.type) {
              case "extra_address_alphabetical_list":
                order.alphabetList.companyAddresses.push({
                  id: shortid.generate(),
                  address: service.order_value
                });
                break;
              case "service_packages":
                order.packagePlacement.selectedMajorPackageIds.push(service.id);
                break;
              case "service_packages_additional":
                order.packagePlacement.selectedAdditionalPackageId.push(
                  service.id
                );
                break;
              case "alphabetical_list_options":
                order.packagePlacement.selectedLogoPlacementIds.push(
                  service.id
                );
                break;
              case "advertising_services_сatalog":
                order.adServices.catalog.push(service.id);
                break;
              case "advertising_services_guide":
                order.adServices.guide.push(service.id);
                break;
              case "other_advertising_services":
                order.adServices.other.push(service.id);
                break;
            }
          }
        });
    }

    if (data.rubrics && data.rubrics.length) {
      order.selectedRubricsId = data.rubrics.map(rubric => {
        return String(rubric.id);
      });

      data.rubrics.forEach(rubric => {
        const extraAddressService = state.info.services.find(
          service => service.type === "extra_address_rubricator"
        ) || { id: null };

        order.selectedServicesForRubrics[rubric.id] =
          rubric?.services
            ?.filter(service => service.id !== extraAddressService.id)
            .map(service => {
              return service.id;
            }) || [];

        rubric.services
          .filter(service => service.id === extraAddressService.id)
          .forEach(service => {
            order.rubricsAddresses.push({
              id: shortid.generate(),
              address: service.order_value,
              rubricId: rubric.id
            });
          });
      });
    }

    if (data.exporter_rubrics && data.exporter_rubrics.length) {
      order.selectedRussianExporterId = data.exporter_rubrics.map(rubric => {
        return String(rubric.id);
      });
    }
    state.info.services
      .filter(service => service.type === "packages_number_categories")
      .forEach(service => {
        const findPackage = data.services.find(item => item.id === service.id);
        if (findPackage && findPackage.quantity > 0) {
          for (let i = 0; i < findPackage.quantity; i++) {
            order.selectedPackagesId.push(service.id);
          }
        }
      });
    order.files = {
      orderFile: data.confirmation || null,
      requisitesFile: data.requisites || null,
      logoFile: data.logo || null,
      coverImg: data.company_cover || null,
      adModulePdf: data.presentation || null,
      adGraphic: data.graphics || null
    };
    commit("UPDATE_CATALOG", order);
    commit("IS_CATALOG_DATA_LOADING", false);
    return data;
  },

  async fetchRubrics({ commit }, eventId) {
    const response = await apiCatalog.getRubrics(eventId);
    if (response && response.data) {
      commit("SET_RUBRICS", response.data);
    }
  },

  updateRubrics({ commit }, rubrics) {
    commit("UPDATE_RUBRICS", rubrics);
  },

  updateRubricsAddresses({ commit }, address) {
    commit("UPDATE_RUBRICS_ADDRESSES", address);
  },

  updateRussianExportersList({ commit }, exporters) {
    commit("UPDATE_RUSSIAN_EXPORTERS_LIST", exporters);
  },

  updateServiceForRubric({ commit }, payload) {
    commit(
      payload.value
        ? "ENABLE_SERVICE_FOR_RUBRIC"
        : "DISABLE_SERVICE_FOR_RUBRIC",
      payload
    );

    if (payload.relatedServiceId) {
      if (payload.value) {
        commit("DISABLE_SERVICE_FOR_RUBRIC", {
          rubricId: payload.rubricId,
          serviceId: payload.relatedServiceId
        });
      } else {
        commit("ENABLE_SERVICE_FOR_RUBRIC", {
          rubricId: payload.rubricId,
          serviceId: payload.relatedServiceId
        });
      }
    }
  },

  updatePackagePlacementMajorPackage({ commit }, packageId) {
    commit("UPDATE_PACKAGE_PLACEMENT_MAJOR_PACKAGE", packageId);
  },

  updatePackagePlacementAdditionalPackage({ commit }, packageId) {
    commit("UPDATE_PACKAGE_PLACEMENT_ADDITIONAL_PACKAGE", packageId);
  },

  updatePackagePlacementLogo({ commit }, { service, value }) {
    commit("UPDATE_PACKAGE_PLACEMENT_LOGO", {
      service,
      value: !!value
    });
  },

  updateAdServiceCatalog({ commit }, { service, value }) {
    commit("UPDATE_AD_SERVICE_CATALOG", {
      service,
      value: !!value
    });
  },

  updateAdServiceGuide({ commit }, { service, value }) {
    commit("UPDATE_AD_SERVICE_GUIDE", {
      service,
      value: !!value
    });
  },

  updateAdServiceOther({ commit }, { service, value }) {
    commit("UPDATE_AD_SERVICE_OTHER", {
      service,
      value: !!value
    });
  },

  deleteRubric({ commit }, rubricId) {
    commit("DELETE_RUBRIC", rubricId);
  },

  setCurrentCurrencyType({ commit }, type) {
    commit("SET_CURRENT_CURRENCY_TYPE", type);
  },

  async setFileOrder({ commit }, payload) {
    const data = new FormData();
    data.set("file", payload.file);
    const result = await apiCatalog.uploadConfirmationFile(
      payload.eventId,
      payload.orderId,
      data
    );

    if (result && result.data) commit("UPDATE_FILE_ORDER", result.data);
  },

  async setFileRequisites({ commit }, payload) {
    const data = new FormData();
    data.set("file", payload.file);
    const result = await apiCatalog.uploadRequisitesFile(
      payload.eventId,
      payload.orderId,
      data
    );

    if (result && result.data) commit("UPDATE_FILE_REQUISITES", result.data);
  },

  async setFilePackage({ commit }, payload) {
    const data = new FormData();
    data.set("file", payload.file);
    try {
      const result = await apiCatalog.uploadPackageFile(
        payload.eventId,
        payload.orderId,
        data,
        payload.type
      );
      if (result?.data && payload.type === "logo") {
        commit("UPDATE_FILE_LOGO", result.data);
      }
      if (result?.data && payload.type === "presentation") {
        commit("UPDATE_FILE_PRESENTATION", result.data);
      }
      if (result?.data && payload.type === "company-cover") {
        commit("UPDATE_FILE_COVER", result.data);
      }
      if (result?.data && payload.type === "graphics") {
        commit("UPDATE_GRAPHIC_FILES", result.data);
      }
    } catch (e) {
      await store.dispatch("common/setErrorMessage", getError(e));
    }
  },

  async removePackageFile({ commit }, { eventId, orderId, fileId, type }) {
    await apiCatalog.destroyPackageFile(eventId, orderId, fileId, type);
    if (type === "logo") {
      commit("UPDATE_FILE_LOGO", null);
    }
    if (type === "presentation") {
      commit("UPDATE_FILE_PRESENTATION", null);
    }
    if (type === "company-cover") {
      commit("UPDATE_FILE_COVER", null);
    }
    if (type === "graphics") {
      commit("UPDATE_GRAPHIC_FILES", null);
    }
  }
};

const getters = {
  catalogStands(state) {
    return state.alphabetList.companyStands || [];
  },
  getCountryList(state) {
    return state.countryList;
  },
  // возвращает количество бесплатных символов для описания
  freeCompanyInfoLength: state => {
    if (!(state.info && state.info.number_free_symbols)) return 0;

    return state.info.number_free_symbols;
  },

  getOrderDataFromCatalog: state => {
    const templateServices =
      state.info && state.info.services ? state.info.services : [];

    const data = {
      step: state.step || 1,
      stands: JSON.stringify(
        state.alphabetList.companyStands?.map(stand => stand.value)
      ),
      currency: state.currentCurrencyType.code,
      name_rus: state.alphabetList.companyName,
      name_eng: state.alphabetList.companyNameEng,
      country_id: state.alphabetList.companyCountry,
      is_russian_exporter: state.alphabetList.companyRussianExporter,
      is_mark: state.alphabetList.companyIsMark,
      is_contract_manufacturing:
        state.alphabetList.companyIsContractManufacturing,

      catalog_country_id: state.alphabetList.companyCountryForBooklet,
      information_rus: state.alphabetList.companyInfo,
      information_eng: state.alphabetList.companyInfoEng,
      type: state.alphabetList.companyOwnerType,
      address: state.alphabetList.companyAddresses?.length
        ? state.alphabetList.companyAddresses[0]?.address
        : "",
      website: state.alphabetList.companySite,
      email: state.alphabetList.companyEmail,
      phone: state.alphabetList.companyPhone,
      fax: state.alphabetList.companyFax,
      logo_link: state.adServices.graphicFilesLink,
      video_link: state.adServices.adVideoFilesLink,
      services: [],
      rubrics: [],
      exporter_rubrics: []
    };

    if (
      state.alphabetList.companyAddresses &&
      state.alphabetList.companyAddresses.length > 1
    ) {
      const extraAddressService = templateServices.find(
        service => service.type === "extra_address_alphabetical_list"
      ) || { id: null };

      for (let i = 1; i < state.alphabetList.companyAddresses.length; i++) {
        data.services.push({
          id: extraAddressService.id,
          order_value: state.alphabetList.companyAddresses[i].address
        });
      }
    }

    let companyInfoLength = state.alphabetList?.companyInfo?.length;
    if (event?.state?.event?.is_not_resident) {
      companyInfoLength = state.alphabetList?.companyInfoEng?.length;
    }

    if (companyInfoLength > getters.freeCompanyInfoLength(state)) {
      const extraLineService = templateServices.find(
        service => service.type === "extra_line_alphabetical_list"
      ) || { id: null };
      if (extraLineService)
        data.services.push({
          id: extraLineService.id
        });
    }

    if (state.selectedRubricsId.length) {
      data.rubrics = state.selectedRubricsId.map(rubric => {
        const selectedServices =
          state.selectedServicesForRubrics[rubric]?.map(service => {
            return {
              id: service
            };
          }) || [];

        const extraAddressService = templateServices.find(
          service => service.type === "extra_address_rubricator"
        ) || { id: null };
        state.rubricsAddresses
          ?.filter(item => item.rubricId === +rubric)
          ?.forEach(item => {
            selectedServices.push({
              id: extraAddressService.id,
              order_value: item.address
            });
          });

        return {
          id: +rubric,
          services: selectedServices
        };
      });
    }

    if (state.packagePlacement.selectedAdditionalPackageId.length) {
      state.packagePlacement.selectedAdditionalPackageId.forEach(
        selectedAdditionalPackageId => {
          data.services.push({
            id: selectedAdditionalPackageId
          });
        }
      );
    }

    if (state.packagePlacement.selectedMajorPackageIds.length) {
      state.packagePlacement.selectedMajorPackageIds.forEach(
        selectedMajorPackageId => {
          data.services.push({
            id: selectedMajorPackageId
          });
        }
      );
    }

    if (state.packagePlacement.selectedLogoPlacementIds.length) {
      state.packagePlacement.selectedLogoPlacementIds.forEach(
        selectedLogoPlacementId => {
          data.services.push({
            id: selectedLogoPlacementId
          });
        }
      );
    }

    if (state.selectedRussianExporterId.length) {
      data.exporter_rubrics = state.selectedRussianExporterId.map(
        exporterId => {
          return {
            id: exporterId
          };
        }
      );
    }

    if (state.adServices.catalog.length) {
      state.adServices.catalog.forEach(adServiceId => {
        data.services.push({
          id: adServiceId
        });
      });
    }

    if (state.adServices.guide.length) {
      state.adServices.guide.forEach(adServiceId => {
        data.services.push({
          id: adServiceId
        });
      });
    }

    if (state.adServices.other.length) {
      state.adServices.other.forEach(adServiceId => {
        data.services.push({
          id: adServiceId
        });
      });
    }

    return data;
  },
  allowUploadLogo(state, getters) {
    const uniqueSelectedRubricsId = [
      ...new Set(Object.values(state.selectedServicesForRubrics).flat(2)),
      ...state.selectedPackagesId
    ];
    const servArr = [
      ...state.packagePlacement.selectedLogoPlacementIds,
      ...state.packagePlacement.selectedMajorPackageIds,
      ...state.packagePlacement.selectedAdditionalPackageId,
      ...uniqueSelectedRubricsId
    ];

    return servArr.some(
      item => getters.requiredLogoServices?.includes(item) || false
    );
  },

  allowUploadCoverFiles(state, getters) {
    const servArr = [
      ...state.packagePlacement.selectedLogoPlacementIds,
      ...state.packagePlacement.selectedMajorPackageIds,
      ...state.packagePlacement.selectedAdditionalPackageId
    ];
    return servArr.some(
      item => getters.requiredAdModule?.includes(item) || false
    );
  },
  priceTypes: state => {
    return currencies.filter(
      item => state.info?.currencies?.includes(item.code) || item.code === "RUR"
    );
  },

  // возвращает кол-во символов в "строке" для подсчета после бесплатных символов
  companyInfoStringLength: state => {
    if (!(state.info && state.info.number_characters_string)) return 0;

    return state.info.number_characters_string;
  },

  // возвращает цену за дополнительную строку в информации о компании без НДС
  companyInfoAdditionalStringPrice: state => {
    if (!(state.info && state.info.services && state.info.services.length))
      return {
        price: 0,
        errorPrice: true
      };

    let result = state.info.services.find(
      service => service.type === "extra_line_alphabetical_list"
    );

    if (result.prices?.length) {
      const price = result.prices.filter(
        item => item.currency === state.currentCurrencyType.code
      );
      return {
        price: +price[0]?.price_without_vat,
        errorPrice: +price[0]?.price_without_vat === null
      };
    } else {
      return {
        price: 0,
        errorPrice: true
      };
    }
  },

  extraAddressAlphabeticalList: state => {
    const service =
      state.info.services.find(
        service => service.type === "extra_address_alphabetical_list"
      ) || {};

    return {
      ...service,
      images: service?.images?.map(
        image => `${process.env.VUE_APP_URL}storage/${image.original_path}`
      )
    };
  },

  extraAddressRubricator: state => {
    const service =
      state.info.services.find(
        service => service.type === "extra_address_rubricator"
      ) || {};

    return {
      ...service,
      images: service?.images?.map(
        image => `${process.env.VUE_APP_URL}storage/${image.original_path}`
      )
    };
  },

  // возвращает цену за дополнительный адрес у компании без НДС
  additionalCompanyAddressPrice: (state, getters) => {
    if (!(state.info && state.info.services && state.info.services.length))
      return {
        price: 0,
        errorPrice: true
      };

    const currentPrices = getters.extraAddressAlphabeticalList?.prices?.filter(
      price => price.currency === state.currentCurrencyType.code
    );

    if (currentPrices.length) {
      return {
        price: +currentPrices[0].price_without_vat,
        errorPrice: false
      };
    } else {
      return {
        price: 0,
        errorPrice: true
      };
    }
  },

  // возвращает цену за дополнительный адрес у rubricator без НДС
  additionalRubricatorAddressPrice: (state, getters) => {
    if (!(state.info && state.info.services && state.info.services.length))
      return {
        price: 0,
        errorPrice: true
      };

    const currentPrices =
      getters.extraAddressRubricator?.prices?.filter(
        price => price.currency === state.currentCurrencyType.code
      ) || [];

    if (currentPrices.length) {
      return {
        price: +currentPrices[0].price_without_vat,
        errorPrice: false
      };
    } else {
      return {
        price: 0,
        errorPrice: true
      };
    }
  },

  totalPriceForCompanyAddresses: (state, getters) => {
    const companyAddresses = state.alphabetList.companyAddresses;

    if (!Array.isArray(companyAddresses) || companyAddresses.length <= 1) {
      return 0;
    }

    return (
      (companyAddresses.filter(x => !!x.address.trim()?.length)?.length - 1) *
      getters.additionalCompanyAddressPrice.price
    );
  },

  totalPriceForRubricAddresses: (state, getters) => {
    if (!state.rubricsAddresses?.length) {
      return 0;
    }

    return (
      state.rubricsAddresses.filter(x => !!x?.address?.trim()?.length).length *
      getters.additionalRubricatorAddressPrice.price
    );
  },

  isCompanyExporterFlagAllowed: state => {
    return !!(state.info && state.info.is_russian_exporter);
  },

  isMark: state => {
    return state.info.is_mark;
  },

  markValue: state => {
    return i18n.locale === "en"
      ? state.info.mark_title_eng
      : state.info.mark_title_rus;
  },

  isContractManufacturing: state => {
    return state.info.is_contract_manufacturing;
  },

  requiredLogoServices: state => {
    return state.info.services
      .filter(service => service.is_required_logo)
      .map(service => service.id);
  },
  requiredAdModule: state => {
    return state.info.services
      .filter(service => service.is_required_ad_module)
      .map(service => service.id);
  },
  requiredGraphicFileServices: state => {
    return state.info.services
      .filter(service => service.is_required_graphic_file)
      .map(service => service.id);
  },

  // Возвращает кол-во бесплатных рубрик.
  freeRubricsCount: state => {
    if (!(state.info && state.info.number_free_rubrics)) return 0;

    return state.info.number_free_rubrics;
  },

  // Возвращает цену за дополнительную рубрику
  additionalRubricPrice: state => {
    if (!state.info?.services?.length)
      return {
        price: 0,
        errorPrice: true
      };

    let result = state.info.services.find(
      service => service.type === "extra_information_company_rubric"
    );

    if (result.prices && result.prices.length > 0) {
      return {
        price: +result.prices[0].price_without_vat,
        errorPrice: false
      };
    } else {
      return {
        price: 0,
        errorPrice: true
      };
    }
  },

  // Трансформирует списку рубрик из 1С для формата приложение
  rubricsList: state => {
    return eventCatalogHelper.filterRubricsByExporter(state.rubrics, false);
  },

  // Возвращает кол-во бесплатных рубрик для Российского экспортера.
  freeRussianExporterCount: state => {
    if (!(state.info && state.info.number_free_rubrics)) return 0;

    return state.info.number_free_rubrics;
  },

  // Трансформирует список Российских экспортеров из 1С для формата приложение
  russianExporterList: state => {
    return eventCatalogHelper.filterRubricsByExporter(state.rubrics, true);
  },

  selectedRussianExporterList: (state, getters) => {
    if (!getters.russianExporterList) {
      return [];
    }

    return getters.russianExporterList
      .filter(x => {
        return state.selectedRussianExporterId.indexOf(x.id) > -1;
      })
      .map(exporter => {
        return {
          id: exporter.id,
          code: exporter.code,
          title: `${exporter.code}. ${
            i18n.locale === "en" ? exporter.name_eng : exporter.name_rus
          }`,
          defaultTitle: `${exporter.code}. ${
            i18n.locale === "en" ? exporter.name_eng : exporter.name_rus
          }`,
          onlyTitle:
            i18n.locale === "en" ? exporter.name_eng : exporter.name_rus
        };
      });
  },

  shortInfoRubricServiceId: state => {
    const shortService = state.info.services.find(
      service => service.type === "brief_information_rubricator"
    ) || { id: null };

    return shortService.id;
  },

  // Отдает услуги для каждой рубрики
  rubricServices: state => {
    if (!(state.info.services && state.info.services.length)) {
      return [];
    }

    const t = [];

    const shortInfoService = state.info.services.find(
        service => service.type === "brief_information_rubricator"
      ),
      fullInfoService = state.info.services.find(
        service => service.type === "full_information_rubricator"
      );

    if (shortInfoService) {
      const targetPriceList = shortInfoService.prices
        .filter(el => el.currency === state.currentCurrencyType.code)
        .shift();

      t.push({
        id: shortInfoService.id,
        title:
          i18n.locale === "en"
            ? shortInfoService.name_eng
            : shortInfoService.name_rus,
        description:
          i18n.locale === "en"
            ? shortInfoService.description_eng
            : shortInfoService.description_rus,
        price:
          targetPriceList && targetPriceList.price_without_vat
            ? +targetPriceList.price_without_vat
            : 0,
        errorPrice:
          !targetPriceList ||
          (targetPriceList && !targetPriceList.price_without_vat),
        images: shortInfoService.images.map(
          image => `${process.env.VUE_APP_URL}storage/${image.original_path}`
        ),
        relatedServiceId: fullInfoService ? fullInfoService.id : undefined,
        isShortInfoService: true
      });
    }

    if (fullInfoService) {
      const targetPriceList = fullInfoService.prices
        .filter(el => el.currency === state.currentCurrencyType.code)
        .shift();

      t.push({
        id: fullInfoService.id,
        title:
          i18n.locale === "en"
            ? fullInfoService.name_eng
            : fullInfoService.name_rus,
        description:
          i18n.locale === "en"
            ? fullInfoService.description_eng
            : fullInfoService.description_rus,
        price:
          targetPriceList && targetPriceList.price_without_vat
            ? +targetPriceList.price_without_vat
            : 0,
        errorPrice:
          !targetPriceList ||
          (targetPriceList && !targetPriceList.price_without_vat),
        images: fullInfoService.images.map(
          image => `${process.env.VUE_APP_URL}storage/${image.original_path}`
        ),
        isFullInfoService: true,
        relatedServiceId: shortInfoService ? shortInfoService.id : undefined
      });
    }

    for (const service of state.info.services.filter(
      service => service.type === "rubricator_options"
    )) {
      const targetPriceList = service.prices
        .filter(el => el.currency === state.currentCurrencyType.code)
        .shift();

      t.push({
        id: service.id,
        title: i18n.locale === "en" ? service.name_eng : service.name_rus,
        description:
          i18n.locale === "en"
            ? service.description_eng
            : service.description_rus,
        price:
          targetPriceList && targetPriceList.price_without_vat
            ? +targetPriceList.price_without_vat
            : 0,
        errorPrice:
          !targetPriceList ||
          (targetPriceList && !targetPriceList.price_without_vat),
        images: service.images.map(
          image => `${process.env.VUE_APP_URL}storage/${image.original_path}`
        )
      });
    }

    return t;
  },

  nestedRubrics: state => {
    return eventCatalogHelper.nestedRubrics(state.rubrics) || [];
  },

  // Возвращает рубрики с привязанными к ним услугами без НДС
  rubricsWithServices: (state, getters) => {
    if (!getters.nestedRubrics.length) {
      return [];
    }

    let freeRubricsLeft = getters.freeRubricsCount;

    // Получаем список выбранных пакетов в рубрикаторе
    let selectedPackageServicesRubricator = [];
    if (state.selectedPackagesId && state.selectedPackagesId.length) {
      state.selectedPackagesId.forEach(el => {
        const objPack = state.info.services.find(pack => pack.id === el);
        if (objPack) {
          selectedPackageServicesRubricator.push(objPack);
        }
      });
    }

    let freeServicesForPackage = {};
    selectedPackageServicesRubricator.forEach(el => {
      if (el.package_contents && el.package_contents.length) {
        el.package_contents.forEach(packageContent => {
          freeServicesForPackage[packageContent.id] = freeServicesForPackage[
            packageContent.id
          ]
            ? freeServicesForPackage[packageContent.id] +
              packageContent.quantity
            : packageContent.quantity || 0;
        });
      }
    });

    return getters.nestedRubrics
      .filter(x => {
        return state.selectedRubricsId.indexOf(x.id.toString()) > -1;
      })
      .map(rubric => {
        // a hack to copy getter from vuex
        const services = JSON.parse(JSON.stringify(getters.rubricServices));

        services.forEach(service => {
          const isSelected =
            Array.isArray(state.selectedServicesForRubrics[rubric.id]) &&
            state.selectedServicesForRubrics[rubric.id].indexOf(service.id) >
              -1;

          if (freeRubricsLeft > 0 && service.isShortInfoService && isSelected) {
            service.price = 0;
            freeRubricsLeft--;
          }
          if (
            service.price !== 0 &&
            freeServicesForPackage[service.id] &&
            freeServicesForPackage[service.id] > 0 &&
            isSelected
          ) {
            service.oldPrice = service.price;
            service.price = 0;
            freeServicesForPackage[service.id]--;
          }

          return service;
        });

        let totalPrice = services.reduce((acc, service) => {
          if (
            state.selectedServicesForRubrics[rubric.id] &&
            state.selectedServicesForRubrics[rubric.id].indexOf(service.id) > -1
          ) {
            acc += service.price;
          }

          return acc;
        }, 0);

        const totalRubricsAdressesPrice =
          state.rubricsAddresses.filter(
            x => !!x?.address?.trim()?.length && x.rubricId === rubric.id
          ).length * getters.additionalRubricatorAddressPrice.price;

        totalPrice += totalRubricsAdressesPrice;

        return {
          id: rubric.id,
          code: `${rubric.code}.`,
          title: `${rubric.code}. ${
            i18n.locale !== "en" ? rubric.name_rus : rubric.name_eng
          }`,
          onlyTitle: i18n.locale === "en" ? rubric.name_eng : rubric.name_rus,
          services,
          totalPrice
        };
      });
  },

  rubricsPackages: state => {
    if (!(state.info && state.info.services && state.info.services.length))
      return [];

    return state.info.services
      .filter(service => service.type === "packages_number_categories")
      .sort((a, b) => a.order - b.order)
      .map(service => {
        const price = service.prices.find(
          price => price.currency === state.currentCurrencyType.code
        );

        return {
          id: service.id,
          title: i18n.locale === "en" ? service.name_eng : service.name_rus,
          subtitle:
            i18n.locale === "en"
              ? service.description_eng
              : service.description_rus,
          uiTitle: `${i18n.locale === "en" ? "Package" : "Пакет"} ${
            service.order
          }`,
          price:
            price && price.price_without_vat ? +price.price_without_vat : 0,
          errorPrice: !price || !(price && price.price_without_vat),
          images: service.images.map(
            image => `${process.env.VUE_APP_URL}storage/${image.original_path}`
          ),
          services:
            service.package_contents && service.package_contents.length
              ? service.package_contents.reduce(
                  (compositionAcc, compositionItem) => {
                    if (compositionAcc[compositionItem.id]) {
                      compositionAcc[compositionItem.id] =
                        compositionItem.quantity;
                    } else {
                      compositionAcc[compositionItem.id] =
                        compositionItem.quantity;
                    }

                    return compositionAcc;
                  },
                  {}
                )
              : [],
          servicesPriceList:
            service.package_contents && service.package_contents.length
              ? service.package_contents.map(content => {
                  const contentService = state.info.services.find(
                    serviceEl => serviceEl.id === content.id
                  );

                  const targetPriceList = contentService.prices.find(
                    price => price.currency === state.currentCurrencyType.code
                  );

                  return {
                    id: contentService.id,
                    price:
                      targetPriceList && targetPriceList.price_without_vat
                        ? +targetPriceList.price_without_vat
                        : 0,
                    errorPrice:
                      !targetPriceList ||
                      (targetPriceList && !targetPriceList.price_without_vat),
                    title:
                      i18n.locale === "en"
                        ? contentService.name_eng
                        : contentService.name_rus
                  };
                })
              : []
        };
      });
  },

  selectedRubricsPackages: (state, getters) => {
    let result = [];

    const assSelectedPackages = state.selectedPackagesId.reduce((acc, rec) => {
      return typeof acc[rec] !== "undefined"
        ? { ...acc, [rec]: acc[rec] + 1 }
        : { ...acc, [rec]: 1 };
    }, {});

    for (let el in assSelectedPackages) {
      if (el && assSelectedPackages && assSelectedPackages[el]) {
        const p = getters.rubricsPackages.find(p => +p.id === +el);
        result.push({
          ...p,
          count: assSelectedPackages[el]
        });
      }
    }

    return result;
  },

  // возвращает основные пакетные услуги для раздела "пакетное размещение" без НДС
  packagePlacementMajorPackages: state => {
    if (!state.info || !state.info.services || !state.info.services.length) {
      return [];
    }
    return state.info.services
      .filter(x => x.type === "service_packages" && x.is_package === true)
      .sort((a, b) => a.order - b.order)
      .map(x => {
        const composition =
          x.package_contents && x.package_contents.length
            ? x.package_contents
                .filter(packageContent => {
                  return state.info.services.find(service => {
                    return service.id === packageContent.id;
                  });
                })
                .map(packageContent => {
                  const packageContentService = state.info.services.find(
                    service => {
                      return service.id === packageContent.id;
                    }
                  );

                  return {
                    title:
                      i18n.locale === "en"
                        ? packageContentService.name_eng
                        : packageContentService.name_rus,
                    description:
                      i18n.locale === "en"
                        ? packageContentService.description_eng
                        : packageContentService.description_rus,
                    isLogoRequired: packageContentService.is_required_logo,
                    isGraphicsFileRequired:
                      packageContentService.is_required_graphic_file,
                    icon: null
                  };
                })
            : [];

        const targetPriceList = x.prices.find(
          el => el.currency === state.currentCurrencyType.code
        );

        const servicesHTML =
          "<ul>" +
          (i18n.locale === "en" ? x.description_eng : x.description_rus)
            .split("\n")
            .map(serviceText => {
              return `<li><p>${serviceText}</p></li>`;
            })
            .join("") +
          "</ul>";

        return {
          id: x.id,
          title: i18n.locale === "en" ? x.name_eng : x.name_rus,
          description:
            i18n.locale === "en" ? x.description_eng : x.description_rus,
          servicesHTML: servicesHTML,
          price:
            targetPriceList && targetPriceList.price_without_vat
              ? +targetPriceList.price_without_vat
              : 0,
          errorPrice:
            !targetPriceList ||
            (targetPriceList && !targetPriceList.price_without_vat),
          images: x.images.map(
            image => `${process.env.VUE_APP_URL}storage/${image.original_path}`
          ),
          list: composition,
          isLogoRequired: x.is_required_logo,
          isGraphicsFileRequired: x.is_required_graphic_file
        };
      });
  },

  // возвращает дополнительные пакетные услуги для раздела "пакетное размещение"
  packagePlacementAdditionalPackages: state => {
    if (!state.info || !state.info.services || !state.info.services.length) {
      return [];
    }

    return state.info.services
      .filter(
        x => x.type === "service_packages_additional" && x.is_package === true
      )
      .sort((a, b) => a.order - b.order)
      .map(x => {
        const composition =
          x.package_contents && x.package_contents.length
            ? x.package_contents
                .filter(packageContent => {
                  return state.info.services.find(service => {
                    return service.id === packageContent.id;
                  });
                })
                .map(packageContent => {
                  const packageContentService = state.info.services.find(
                    service => {
                      return service.id === packageContent.id;
                    }
                  );

                  return i18n.locale === "en"
                    ? packageContentService.name_eng
                    : packageContentService.name_rus;
                })
            : [];

        const targetPriceList = x.prices.find(
          el => el.currency === state.currentCurrencyType.code
        );

        const servicesHTML =
          "<ul>" +
          (i18n.locale === "en" ? x.description_eng : x.description_rus)
            .split("\n")
            .map(serviceText => {
              return `<li><p>${serviceText}</p></li>`;
            })
            .join("") +
          "</ul>";

        return {
          id: x.id,
          title: i18n.locale === "en" ? x.name_eng : x.name_rus,
          description:
            i18n.locale === "en" ? x.description_eng : x.description_rus,
          servicesHTML: servicesHTML,
          price:
            targetPriceList && targetPriceList.price_without_vat
              ? +targetPriceList.price_without_vat
              : 0,
          errorPrice:
            !targetPriceList ||
            (targetPriceList && !targetPriceList.price_without_vat),
          images: x.images.map(
            image => `${process.env.VUE_APP_URL}storage/${image.original_path}`
          ),
          list: composition,
          isLogoRequired: x.is_required_logo,
          isGraphicsFileRequired: x.is_required_graphic_file
        };
      });
  },

  // возвращает размещение логотипа для раздела "пакетное размещение"
  packagePlacementLogo: state => {
    if (!state.info || !state.info.services || !state.info.services.length) {
      return [];
    }

    return state.info.services
      .filter(x => x.type === "alphabetical_list_options")
      .map(x => {
        const targetPriceList = x.prices.find(
          el => el.currency === state.currentCurrencyType.code
        );

        return {
          id: x.id,
          title: i18n.locale === "en" ? x.name_eng : x.name_rus,
          price:
            targetPriceList && targetPriceList.price_without_vat
              ? +targetPriceList.price_without_vat
              : 0,
          errorPrice:
            !targetPriceList ||
            (targetPriceList && !targetPriceList.price_without_vat),
          isLogoRequired: x.is_required_logo,
          isGraphicsFileRequired: x.is_required_graphic_file
        };
      });
  },

  // возвращает данные по "Рекламная услуга в каталоге" в разделе "Рекламные услуги"
  adServicesCatalog: state => {
    if (!state.info || !state.info.services || !state.info.services.length) {
      return [];
    }

    return state.info.services
      .filter(x => x.type === "advertising_services_сatalog")
      .map(x => {
        const targetPriceList = x.prices.find(
          el => el.currency === state.currentCurrencyType.code
        );

        return {
          id: x.id,
          title: i18n.locale === "en" ? x.name_eng : x.name_rus,
          description:
            i18n.locale === "en" ? x.description_eng : x.description_rus,
          price:
            targetPriceList && targetPriceList.price_without_vat
              ? +targetPriceList.price_without_vat
              : 0,
          images: x.images.map(
            image => `${process.env.VUE_APP_URL}storage/${image.original_path}`
          ),
          errorPrice:
            !targetPriceList ||
            (targetPriceList && !targetPriceList.price_without_vat),
          isLogoRequired: x.is_required_logo,
          isGraphicsFileRequired: x.is_required_graphic_file
        };
      });
  },

  // возвращает данные по "Рекламная услуга в путеводителе" в разделе "Рекламные услуги"
  adServicesGuide: state => {
    if (!state.info || !state.info.services || !state.info.services.length) {
      return [];
    }

    return state.info.services
      .filter(x => x.type === "advertising_services_guide")
      .map(x => {
        const targetPriceList = x.prices.find(
          el => el.currency === state.currentCurrencyType.code
        );

        return {
          id: x.id,
          title: i18n.locale === "en" ? x.name_eng : x.name_rus,
          description:
            i18n.locale === "en" ? x.description_eng : x.description_rus,
          price:
            targetPriceList && targetPriceList.price_without_vat
              ? +targetPriceList.price_without_vat
              : 0,
          images: x.images.map(
            image => `${process.env.VUE_APP_URL}storage/${image.original_path}`
          ),
          errorPrice:
            !targetPriceList ||
            (targetPriceList && !targetPriceList.price_without_vat),
          isLogoRequired: x.is_required_logo,
          isGraphicsFileRequired: x.is_required_graphic_file
        };
      });
  },

  // возвращает данные по "Рекламная услуга в путеводителе" в разделе "Рекламные услуги" без НДС
  adServicesOther: state => {
    if (!state.info || !state.info.services || !state.info.services.length) {
      return [];
    }

    return state.info.services
      .filter(x => x.type === "other_advertising_services")
      .map(x => {
        const targetPriceList = x.prices.find(
          el => el.currency === state.currentCurrencyType.code
        );

        return {
          id: x.id,
          title: i18n.locale === "en" ? x.name_eng : x.name_rus,
          description:
            i18n.locale === "en" ? x.description_eng : x.description_rus,
          images: x.images.map(
            image => `${process.env.VUE_APP_URL}storage/${image.original_path}`
          ),
          price:
            targetPriceList && targetPriceList.price_without_vat
              ? +targetPriceList.price_without_vat
              : 0,
          errorPrice:
            !targetPriceList ||
            (targetPriceList && !targetPriceList.price_without_vat),
          isLogoRequired: x.is_required_logo,
          isGraphicsFileRequired: x.is_required_graphic_file
        };
      });
  },

  // Проверяет разрешен ли переход на "рубрикатор"
  isRubricsStepAllowed: state => {
    const regexCompanyNameEng = /[а-яА-ЯЁ]/gi;
    const validCompanyNameEng = !regexCompanyNameEng.test(
      state.alphabetList.companyNameEng
    );

    const isValidCompanyInfo = state.alphabetList.companyInfo
      ? !eventCatalogHelper.isCompanyInfoFalseSymbols(
          state.alphabetList.companyInfo
        )
      : true;
    const isValidCompanyInfoEng = state.alphabetList.companyInfoEng
      ? !eventCatalogHelper.isCompanyInfoFalseSymbols(
          state.alphabetList.companyInfoEng,
          "eng"
        )
      : true;

    return (
      state.invalidStands.length === 0 &&
      !!state.alphabetList.companyName &&
      !!state.alphabetList.companyNameEng &&
      validCompanyNameEng &&
      !!state.alphabetList.companyCountryForBooklet &&
      !!state.alphabetList.companyCountry &&
      isValidCompanyInfo &&
      isValidCompanyInfoEng &&
      state.alphabetList?.companyStands?.every(
        item => item.value?.trim()?.length
      ) &&
      state.alphabetList?.companyStands?.length
    );
  },

  // Проверяет разрешен ли переход на "пакетное размещение"
  isPackagePlacementStepAllowed: state => {
    return !!state.selectedRubricsId.length;
  },

  // Проверяет разрешен ли переход на следующий шаг
  isNextStepAllowed: (state, getters) => {
    switch (state.step) {
      case steps.ALPHABET_LIST:
        return getters.isRubricsStepAllowed;

      case steps.RUBRICS:
        return getters.isPackagePlacementStepAllowed;
      case steps.PREVIEW:
        // Кнопка отправить доступна когда выполняются все условия:
        // - нет ошибок в ценах услуг
        // - цена 0 или (цена != 0 и при этом загружен файл подписанной заявки)
        return (
          !getters.errorPriceServices &&
          (!getters.totalOrderSum ||
            (getters.totalOrderSum && state.files.orderFile))
        );

      default:
        return true;
    }
  },

  totalOrderSum: (state, getters) => {
    let sum = 0;

    let companyInfoLength = state.alphabetList?.companyInfo?.length;
    if (event?.state?.event?.is_not_resident) {
      companyInfoLength = state.alphabetList?.companyInfoEng?.length;
    }

    // Алфавитный список участников
    if (companyInfoLength) {
      sum +=
        Math.ceil(
          Math.max(companyInfoLength - getters.freeCompanyInfoLength, 0) /
            getters.companyInfoStringLength
        ) * getters.companyInfoAdditionalStringPrice.price;
    }

    // Цена за адреса компании
    sum += getters.totalPriceForCompanyAddresses;

    // Цена за адреса рубрик
    sum += getters.totalPriceForRubricAddresses;

    // Пакетное размещение: размещение логотипа
    sum += getters.packagePlacementLogo
      .filter(
        service =>
          state.packagePlacement.selectedLogoPlacementIds.indexOf(service.id) >
          -1
      )
      .reduce((acc, x) => acc + x.price, 0);

    // Пакетное размещение: основной пакет
    sum += getters.packagePlacementMajorPackages
      .filter(
        service =>
          state.packagePlacement.selectedMajorPackageIds.indexOf(service.id) >
          -1
      )
      .reduce((acc, x) => acc + x.price, 0);

    // Пакетное размещение: дополнительный пакет
    sum += getters.packagePlacementAdditionalPackages
      .filter(
        service =>
          state.packagePlacement.selectedAdditionalPackageId.indexOf(
            service.id
          ) > -1
      )
      .reduce((acc, x) => acc + x.price, 0);

    // Рекламные услуги: блок в каталоге
    sum += getters.adServicesCatalog
      .filter(x => state.adServices.catalog.indexOf(x.id) > -1)
      .reduce((acc, x) => acc + x.price, 0);

    // Рекламные услуги: путеводитель
    sum += getters.adServicesGuide
      .filter(x => state.adServices.guide.indexOf(x.id) > -1)
      .reduce((acc, x) => acc + x.price, 0);

    // Рекламные услуги: прочие
    sum += getters.adServicesOther
      .filter(x => state.adServices.other.indexOf(x.id) > -1)
      .reduce((acc, x) => acc + x.price, 0);

    // Рубрикатор
    sum += getters.rubricsWithServices.reduce((total, rubric) => {
      return (
        total +
        rubric.services.reduce((acc, service) => {
          if (
            state.selectedServicesForRubrics[rubric.id] &&
            state.selectedServicesForRubrics[rubric.id].indexOf(service.id) > -1
          ) {
            acc += service.price;
          }

          return acc;
        }, 0)
      );
    }, 0);

    // Рубрикатор: пакеты
    getters.selectedRubricsPackages.forEach(el => {
      sum += el.price * el.count;
    });

    return sum;
  },
  totalOrderSumWithVAT: (state, getters) => {
    return getters.totalOrderSum > 0
      ? +(getters.totalOrderSum * 1.22).toFixed(6)
      : 0;
  },

  errorPriceServices: (state, getters) => {
    // Алфавитный список участников
    if (
      state.alphabetList &&
      state.alphabetList.companyInfo &&
      getters.companyInfoAdditionalStringPrice &&
      getters.companyInfoAdditionalStringPrice.errorPrice
    ) {
      const count = Math.ceil(
        Math.max(
          state.alphabetList.companyInfo.replace(/(?:\r\n|\r|\n)/g, "").length -
            getters.freeCompanyInfoLength,
          0
        ) / getters.companyInfoStringLength
      );
      if (count) {
        return true;
      }
    }

    // Цена за адреса компании
    if (
      getters.totalPriceForCompanyAddresses &&
      getters.additionalCompanyAddressPrice &&
      getters.additionalCompanyAddressPrice.errorPrice
    ) {
      return true;
    }

    // Пакетное размещение: размещение логотипа
    const selectedPackagePlacementLogo = getters.packagePlacementLogo.filter(
      service =>
        state.packagePlacement.selectedLogoPlacementIds.indexOf(service.id) > -1
    );
    if (
      selectedPackagePlacementLogo &&
      selectedPackagePlacementLogo.length &&
      selectedPackagePlacementLogo.find(el => el.errorPrice)
    ) {
      return true;
    }

    // Пакетное размещение: основной пакет
    const selectedMajorPackages = getters.packagePlacementMajorPackages.filter(
      service =>
        state.packagePlacement.selectedMajorPackageIds.indexOf(service.id) > -1
    );
    if (
      selectedMajorPackages &&
      selectedMajorPackages.length &&
      selectedMajorPackages.find(el => el.errorPrice)
    ) {
      return true;
    }

    // Пакетное размещение: дополнительный пакет
    const ppAdditionalPackage = getters.packagePlacementAdditionalPackages.filter(
      service =>
        state.packagePlacement.selectedAdditionalPackageId.indexOf(service.id) >
        -1
    );
    if (
      ppAdditionalPackage &&
      ppAdditionalPackage.length &&
      ppAdditionalPackage.find(el => el.errorPrice)
    ) {
      return true;
    }

    // Рекламные услуги: блок в каталоге
    const selectedAdServicesCatalog = getters.adServicesCatalog.filter(
      x => state.adServices.catalog.indexOf(x.id) > -1
    );
    if (
      selectedAdServicesCatalog &&
      selectedAdServicesCatalog.length &&
      selectedAdServicesCatalog.find(el => el.errorPrice)
    ) {
      return true;
    }

    // Рекламные услуги: путеводитель
    const selectedAdServicesGuide = getters.adServicesGuide.filter(
      x => state.adServices.guide.indexOf(x.id) > -1
    );
    if (
      selectedAdServicesGuide &&
      selectedAdServicesGuide.length &&
      selectedAdServicesGuide.find(el => el.errorPrice)
    ) {
      return true;
    }

    // Рекламные услуги: прочие
    const selectedAdServicesOther = getters.adServicesOther.filter(
      x => state.adServices.other.indexOf(x.id) > -1
    );
    if (
      selectedAdServicesOther &&
      selectedAdServicesOther.length &&
      selectedAdServicesOther.find(el => el.errorPrice)
    ) {
      return true;
    }

    // Рубрикатор
    getters.rubricsWithServices.forEach(rubric => {
      rubric.services.forEach(service => {
        if (
          state.selectedServicesForRubrics[rubric.id] &&
          state.selectedServicesForRubrics[rubric.id].indexOf(service.id) >
            -1 &&
          service.errorPrice
        ) {
          return true;
        }
      }, 0);
    }, 0);

    // Рубрикатор: пакеты
    getters.selectedRubricsPackages.forEach(el => {
      if (el.errorPrice) return true;
    });

    return false;
  },

  currencySymbol: () => {
    return state.currentCurrencyType.symbol;
  },

  managers: state => {
    if (!state.info || !state.info.managers || !state.info.managers.length) {
      return [];
    }

    return state.info.managers;
  }
};

export default {
  namespaced: true,

  state,
  mutations,
  actions,
  getters
};
